export default "__VITE_ASSET__YqowtP84__"